import getDrawerPaneId from "owa-app-pane-group-utils/lib/getDrawerPaneId";
import { PinnablePane } from "owa-outlook-service-option-store";
import { isTimePanelAvailable, openTimePanel } from "owa-time-panel-bootstrap";
import type { PinnablePaneRegistration, PinnablePaneRegistrations, RegisteredPinnablePane, } from "../schema/PinnablePaneRegistrations";
import { isCopilotChatPaneAvailable } from "./isCopilotChatPaneAvailable";
import isMatchingPaneId from "./isMatchingPaneId";
import isFlexPaneShownHelper from "owa-app-pane-group-utils/lib/helpers/isFlexPaneShownHelper";
import { handleCopilotChatAutoOpen } from "./handleCopilotChatAutoOpen";

const CHAT_COPILOT_FLEXPANE_ID = "ChatCopilot"; // match with owa-copilot-chat utils

const registrations: PinnablePaneRegistrations = {
    [PinnablePane.MyDay]: {
        flexPaneId: "OwaTimePanel",
        headerPaneId: getDrawerPaneId("myDay"),
        shouldAutoOpen: isTimePanelAvailable,
        handleAutoOpen: () => openTimePanel("AutoOpen"),
    },
    [PinnablePane.CopilotChat]: {
        flexPaneId: CHAT_COPILOT_FLEXPANE_ID,
        headerPaneId: getDrawerPaneId("chatCopilot"),
        shouldAutoOpen: isCopilotChatPaneAvailable,
        handleAutoOpen: handleCopilotChatAutoOpen,
    },
};

export function getPinnablePaneRegistration(pinnablePane: RegisteredPinnablePane): PinnablePaneRegistration {
    return registrations[pinnablePane];
}

export function getPinnablePaneByFlexPaneId(flexPaneId: string): RegisteredPinnablePane | undefined {
    for (const [pinnedPane, registration] of Object.entries(registrations)) {
        if (isMatchingPaneId(registration, flexPaneId)) {
            // object keys are coerced as strings, so need to convert back to number
            return Number(pinnedPane);
        }
    }
    
    return undefined;
}

// This function checks if the currently opened flex pane is a pinnable pane.
// If so, it will return the corresponding PinnablePane.
// If not (no FlexPane shown or no matching registration), it will return PinnablePane.None.
export function getCurrentPinnablePane(): PinnablePane {
    for (const [pinnablePane, registration] of Object.entries(registrations)) {
        if (isFlexPaneShownHelper(registration.flexPaneId)) {
            return pinnablePane;
        }
    }
    return PinnablePane.None;
}
